/**
 * Path of the page the user is on, for the `bo-current-screen` request header.
 *
 * The query string is dropped on purpose - react-admin puts list filters there
 */
export const getCurrentScreen = (): string =>
  window.location.hash.replace(/^#/, '').split('?')[0] || '/';
